var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bid_wrap"},[_c('item-detail-component',{attrs:{"item-type":'itemPrice',"item-key":_vm.itemKey}}),_c('commission-info-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }